import React from 'react';
import { Autocomplete, Stack, TextField } from '@mui/material';

import { formatSkillLabel } from '@utils';
import { FilterSectionTitle } from 'components/candidate/CandidatesList/components/CandidateFilterSections';

export const SkillFilterField: React.FC<{
  title: string;
  label: string;
  skills: string[];
  selected: string[];
  onChange: (skills: string[]) => void;
}> = ({ title, label, skills, selected, onChange }) => (
  <Stack gap={1}>
    <FilterSectionTitle>{title}</FilterSectionTitle>
    <Autocomplete
      multiple
      size="small"
      options={skills}
      value={selected}
      getOptionLabel={formatSkillLabel}
      onChange={(_, value) => onChange(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={`Add ${label}…`}
          inputProps={{ ...params.inputProps, 'aria-label': `Add ${label}` }}
        />
      )}
    />
  </Stack>
);
